import { type useGuides } from "@knocklabs/react";
import { useEffect } from "react";

/**
 * Marks a Knock guide step as seen when the consumer mounts.
 *
 * @example
 * ```tsx
 * const { guides } = useGuides(filter);
 * const step = guides[0].getStep();
 * useKnockMarkAsSeen(step);
 * ```
 */
export function useKnockMarkAsSeen(
  step: ReturnType<ReturnType<typeof useGuides>["guides"][number]["getStep"]>
) {
  useEffect(() => {
    if (step) {
      step.markAsSeen();
    }
  }, [step]);
}
